export const CROP_ASPECT_RATIOS = {
    'org-avatar': {
        aspect: 1 / 1,
        label: 'Square (1:1)',
        description: 'Organization avatar - must be square'
    },
    'user-avatar': {
        aspect: 1 / 1,
        label: 'Square (1:1)',
        description: 'User avatar - must be square'
    },
    'still': {
        aspect: 16 / 9,
        label: 'Landscape (16:9)',
        description: 'Movie still - landscape format'
    },
    'logo': {
        aspect: 2 / 1,
        label: 'Landscape (2:1)',
        description: 'Movie logo - landscape format'
    },
    'poster': {
        aspect: 2 / 3,
        label: 'Portrait (2:3)',
        description: 'Movie poster - portrait format'
    },
    'crew': {
        aspect: 2 / 3,
        label: 'Portrait (2:3)',
        description: 'Crew member photo - portrait format'
    }
};

export const getCropAspect = (mediaType) => {
    return CROP_ASPECT_RATIOS[mediaType] || CROP_ASPECT_RATIOS['user-avatar'];
};
